import { useState } from 'react';
import './PromoCodeModal.css';

const PromoCodeModal = ({ isOpen, onClose }) => {
  const [promoCode, setPromoCode] = useState('');
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleApply = () => {
    if (!promoCode.trim()) {
      setError('Por favor ingresa un código');
      return;
    }
    
    // Siempre muestra código no válido
    setError('Código no válido');
  };

  const handleClose = () => {
    setPromoCode('');
    setError('');
    onClose();
  };

  return (
    <div className="promo-modal-overlay" onClick={handleClose}>
      <div className="promo-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="promo-modal-header">
          <h2>🏷️ Código Promocional</h2>
          <button className="promo-modal-close" onClick={handleClose}>×</button>
        </div>
        
        <div className="promo-modal-body">
          <p className="promo-description">
            Ingresa tu código promocional para obtener descuentos especiales
          </p>
          
          <div className="promo-input-group">
            <input
              type="text"
              value={promoCode}
              onChange={(e) => {
                setPromoCode(e.target.value.toUpperCase());
                setError('');
              }}
              placeholder="Ej: PROMO2024"
              className={`promo-input ${error ? 'error' : ''}`}
              autoFocus
            />
            {error && <span className="promo-error">{error}</span>}
          </div>
        </div>

        <div className="promo-modal-footer">
          <button className="btn-cancel" onClick={handleClose}>
            Cancelar
          </button>
          <button className="btn-apply" onClick={handleApply}>
            Aplicar Código
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoCodeModal;
